module.exports = __webpack_public_path__ + "static/assets/21321f62552c731010f16c3a1fb50d19.png";